// extracted by mini-css-extract-plugin
export default {"eula_page":"EulaPage_eula_page__LLFI+"};